module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setup-box"
  }, [_c('m-header', {
    attrs: {
      "title": "设置"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('router-link', {
    staticClass: "flex vux-1px-b",
    attrs: {
      "to": "/userCenter/changPassword",
      "tag": "div"
    }
  }, [_c('span', [_vm._v("修改密码")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-youjiantou-copy"
  })])], 1), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v("退出登录")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18bcd319"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userCenter/SetUp/SetUp.vue
// module id = 524
// module chunks = 0